import {type Configuration, LogLevel, PublicClientApplication} from "@azure/msal-browser";

export function requiredEnv(name: string, value: string | undefined): string {
    if (!value) throw new Error(`[MSAL] Missing env: ${name}`);
    return value;
}

const ENV_MSAL_CLIENT_ID = requiredEnv("VITE_MSAL_CLIENT_ID", import.meta.env.VITE_MSAL_CLIENT_ID);
const ENV_MSAL_KNOWN_AUTHORITIES = requiredEnv("VITE_MSAL_KNOWN_AUTHORITIES", import.meta.env.VITE_MSAL_KNOWN_AUTHORITIES);
const ENV_MSAL_AUTHORITY_SIGNIN = requiredEnv("VITE_MSAL_AUTHORITY_SIGNIN", import.meta.env.VITE_MSAL_AUTHORITY_SIGNIN);
const ENV_MSAL_AUTHORITY_SIGNUP = requiredEnv("VITE_MSAL_AUTHORITY_SIGNUP", import.meta.env.VITE_MSAL_AUTHORITY_SIGNUP);
const ENV_MSAL_REDIRECT_URI = requiredEnv("VITE_MSAL_REDIRECT_URI", import.meta.env.VITE_MSAL_REDIRECT_URI);
const ENV_MSAL_LOGOUT_REDIRECT_URI = requiredEnv("VITE_MSAL_LOGOUT_REDIRECT_URI", import.meta.env.VITE_MSAL_LOGOUT_REDIRECT_URI);
const ENV_MSAL_BASE_SCOPES = requiredEnv("VITE_MSAL_BASE_SCOPES", import.meta.env.VITE_MSAL_BASE_SCOPES);
const ENV_MSAL_API_SCOPES = requiredEnv("VITE_MSAL_API_SCOPES", import.meta.env.VITE_MSAL_API_SCOPES);

export const MSAL_BASE_SCOPES = ENV_MSAL_BASE_SCOPES.split(",").map(s => s.trim()).filter(Boolean);
export const MSAL_API_SCOPES = ENV_MSAL_API_SCOPES.split(",").map(s => s.trim()).filter(Boolean);
export const MSAL_ALL_SCOPES = [...MSAL_BASE_SCOPES, ...MSAL_API_SCOPES];
export const MSAL_AUTHORITY_SIGNIN = ENV_MSAL_AUTHORITY_SIGNIN;
export const MSAL_AUTHORITY_SIGNUP = ENV_MSAL_AUTHORITY_SIGNUP;
export const MSAL_POLICY_SIGNIN = requiredEnv("VITE_MSAL_POLICY_SIGNIN", import.meta.env.VITE_MSAL_POLICY_SIGNIN);
export const MSAL_POLICY_SIGNUP = requiredEnv("VITE_MSAL_POLICY_SIGNUP", import.meta.env.VITE_MSAL_POLICY_SIGNUP);

const config: Configuration = {
    auth: {
        clientId: ENV_MSAL_CLIENT_ID,
        authority: ENV_MSAL_AUTHORITY_SIGNIN,
        knownAuthorities: [ENV_MSAL_KNOWN_AUTHORITIES],
        redirectUri: ENV_MSAL_REDIRECT_URI,
        postLogoutRedirectUri: `${ENV_MSAL_LOGOUT_REDIRECT_URI}`,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
    },
    system: {
        allowRedirectInIframe: false,
        loggerOptions: {
            logLevel: LogLevel.Error,
            loggerCallback(level, message, containsPii) {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    case LogLevel.Info:
                        console.info(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                }
            },
        },
    },
};

export const msalInstance = new PublicClientApplication(config);
